import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
   /* paddingLeft: theme.spacing(18),
    paddingRight: theme.spacing(18),
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    }*/
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: '35px',
    display: 'flex',
    justifyContent: 'center'

  }
}));

const Wrapper = ({ children, padding }) => {
  const classes = useStyles();
  return <div className={padding ? classes.root : null}>{children}</div>;
};

Wrapper.prototypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.bool
};

Wrapper.defaultProps = {
  padding: true
};

export default Wrapper;
